import css from './featuredlink.scss?inline';
import globalStyles from '../../index.scss?inline';	
import { ArgSpecDictionary, TypedVars } from "../component-utils";

const DEBUG_VERBOSE: boolean  = false;
const CLASS_NAME: string = 'HHDSFeaturedLink';
const TAG_NAME: string = 'hhds-featuredlink';
export const HHDSFeaturedLinkTagName: string = "hhds-featuredlink";

// ////////////////////////////////////////////////////////////////////

export class HHDSFeaturedLink extends HTMLElement {

  private vars: TypedVars = new TypedVars(this);
	private shadow: ShadowRoot;	

	constructor() {
		super();
		DEBUG_VERBOSE && console.log(CLASS_NAME, 'constructed');

		this.shadow = this.attachShadow({ mode: 'open' });
		if (!this.shadow) {
			return;
		}

	}

	// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// Lifecycle Methods
	// https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements#using_the_lifecycle_callbacks

	// Invoked each time the custom element is appended into a document-connected element.
  connectedCallback() {

		this.parseAttributes();

		this.render();

		DEBUG_VERBOSE && console.log(`[${TAG_NAME}] Initialised`);
	}

  parseAttributes() {
    this.vars.parse(this, ArgSpecs);
	}

	render() {
		const title = this.vars.get<string>("title");

		this.shadow.innerHTML = `
			<style>${globalStyles}</style>
			<style>${css}</style>
			<a href="${this.vars.get<string>("url")}" target="${this.vars.get<string>("target")}">
			<div class="hhds-featuredlink">
				${title ? `<p class="hhds-featuredlink__title featuredlink--title heading--sans-01">${title}</p>` : ``}
				${this.linkHTML}
			</div>
			</a>
		`;
	}

	get linkHTML() {
		const link = this.vars.get<string>("link"),
			target = this.vars.get<string>("target"),
			url = this.vars.get<string>("url");
	
		if (link && url) {
			return `<hhds-link style="--link-icon-color: white; --link-text-color: white;" target="${target}" href="${url}"><hhds-icon type="arrowright" slot="end"></hhds-icon>${link}</hhds-link>`;
		}
		
		return '';
		
	}

	// Invoked each time the custom element is disconnected from the document's DOM.
	disconnectedCallback() {}

	// Invoked each time the custom element is moved to a new document.
	adoptedCallback() {}

	// Invoked each time one of the custom element's attributes is added, removed, or changed.
	attributeChangedCallback() {}

}

export const ArgSpecs: ArgSpecDictionary = {
	title: {
		description: `Title`,
		defaultValue: "",
		type: String,
	},
	link: {
		description: `Link text`,
		defaultValue: "",
		type: String,
	},
	target: {
		description: `Link target (_self, _blank etc)`,
		defaultValue: "",
		type: String,
	},
	url: {
		description: `Link URL`,
		defaultValue: "",
		type: String,
	},
};

